package com.schoolconnect.app.repository.attendance

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.response.AttendanceHistoryResponse
import com.schoolconnect.app.feature.common.PageRequest
import com.schoolconnect.app.util.scLog

object AttendanceHistoryRepository {
    private const val TAG = "[DATA_RETRIEVE_SC] AttendanceHistoryRepository"

    suspend fun load(
        studentId: String,
        fromDate: String?,
        toDate: String?,
        status: String?,
        pageIndex: Int,
        pageSize: Int
    ): Result<AttendanceHistoryResponse> {
        val safeLimit = pageSize.coerceIn(1, 100)
        val safeOffset = PageRequest(pageIndex, safeLimit).offset
        scLog("$TAG load start studentId=$studentId offset=$safeOffset limit=$safeLimit")
        return KtorApiClient.getAttendanceHistory(
            studentId = studentId,
            fromDate = fromDate,
            toDate = toDate,
            status = status,
            offset = safeOffset,
            limit = safeLimit
        ).onFailure { throwable -> scLog("$TAG load failure studentId=$studentId offset=$safeOffset", throwable) }
    }
}
